import { render, staticRenderFns } from "./Story3.vue?vue&type=template&id=3bcc3f59&scoped=true&lang=pug"
import script from "./Story3.vue?vue&type=script&lang=js"
export * from "./Story3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc3f59",
  null
  
)

export default component.exports